<script setup lang="ts">
/**
 * Footer V2 — Botão "Contate-nos".
 * Renderizado como <a> (link externo) ou <NuxtLink> (rota interna).
 */
const props = defineProps<{
  to: string;
  external?: boolean;
}>();

const { t } = useTexts();

const tag = computed(() =>
  props.external ? 'a' : resolveComponent('NuxtLink'),
);

const linkProps = computed(() =>
  props.external
    ? { href: props.to, target: '_blank', rel: 'noopener noreferrer' }
    : { to: props.to, 'no-prefetch': true },
);
</script>

<template>
  <component
    :is="tag"
    v-bind="linkProps"
    class="footer-v2-contact-btn"
  >
    <svg
      aria-hidden="true"
      class="footer-v2-contact-btn__icon"
      fill="none"
      height="13"
      viewBox="0 0 16 13"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6 0C0.7175 0 0 0.728711 0 1.625V6.5C0 7.39629 0.7175 8.125 1.6 8.125H2.4V9.34375C2.4 9.49863 2.485 9.63828 2.62 9.70683C2.755 9.77539 2.9175 9.76016 3.04 9.66875L5.0675 8.125H8.8C9.6825 8.125 10.4 7.39629 10.4 6.5V1.625C10.4 0.728711 9.6825 0 8.8 0H1.6ZM8.8 8.9375H6.4V9.75C6.4 10.6463 7.1175 11.375 8 11.375H10.9325L12.96 12.9187C13.08 13.0102 13.2425 13.0254 13.38 12.9568C13.5175 12.8883 13.6 12.7486 13.6 12.5937V11.375H14.4C15.2825 11.375 16 10.6463 16 9.75V4.875C16 3.97871 15.2825 3.25 14.4 3.25H11.2V6.5C11.2 7.8457 10.125 8.9375 8.8 8.9375Z"
        fill="#00C9FF"
      />
    </svg>
    <span class="footer-v2-contact-btn__label">{{
      t('footer.contact_us')
    }}</span>
  </component>
</template>

<style scoped lang="scss">
.footer-v2-contact-btn {
  @apply inline-flex items-center justify-center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #00c9ff;
  background: rgba(56, 177, 161, 0.1);
  backdrop-filter: blur(5px);
  color: #fff;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-decoration: none;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;
  cursor: pointer;

  /* Desktop:
       height 30px, padding 8px 10px 7px 11px, gap 10px. */
  @media (min-width: 1024px) {
    height: 30px;
    padding: 8px 10px 7px 11px;
    gap: 10px;
  }

  &:hover {
    background: rgba(56, 177, 161, 0.18);
  }

  &:focus-visible {
    outline: 2px solid rgba(0, 201, 255, 0.7);
    outline-offset: 2px;
  }

  &__icon {
    flex-shrink: 0;
  }

  &__label {
    color: #fff;
    white-space: nowrap;
  }
}
</style>
